import styled from "styled-components";
import colors from "../../../theme/colors";

interface IMobileIcon {
    onClick: any;
    previewFor: string;
    previewSelected: string;
}

interface IIconContainer {
    previewFor: string;
    previewSelected: string;
}

const IconContainer = styled.span<IIconContainer>`
    display: flex;
    align-items: center;
    cursor: pointer;

    svg {
        stroke: ${(props) => props.previewFor === props.previewSelected ? colors.white: colors.placeholder};
    }
`;

const MobileIcon: React.FC<IMobileIcon> = ({onClick, previewFor, previewSelected}) => {
    return (
        <IconContainer onClick={onClick} previewFor={previewFor} previewSelected={previewSelected}>
            <svg width="22" height="39" viewBox="0 0 22 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.66602 3.66662C1.66602 2.56205 2.56145 1.66663 3.66602 1.66663H18.3327C19.4373 1.66663 20.3327 2.56206 20.3327 3.66663V26.3333C20.3327 27.4379 19.4373 28.3333 18.3327 28.3333H3.66601C2.56144 28.3333 1.66602 27.4379 1.66602 26.3333V3.66662Z" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M11.8327 23C11.8327 23.4602 11.4596 23.8333 10.9993 23.8333C10.5391 23.8333 10.166 23.4602 10.166 23C10.166 22.5397 10.5391 22.1666 10.9993 22.1666C11.4596 22.1666 11.8327 22.5397 11.8327 23Z" fill={colors.white} />
            </svg>
        </IconContainer>
    )
}

export default MobileIcon;